import { maxBy } from 'lodash';

import { UseProductivityRiskTrendProvider } from 'components/widgets/ProductivityRiskTrend/ProductivityRiskTrend.provider';
import { maxValueScale } from 'components/widgets/ProjectSummary/components/CardsSection/CardsSection.utils';

interface Props {
    api: UseProductivityRiskTrendProvider['api'];
}

export const useProductivityRiskTrendLogic = ({ api }: Props) => {
    const maxValuePoint = maxBy(api.getProductivityRiskTrend.instance.data?.[0]?.graphPoints, 'score');
    const maxValue = maxValuePoint ? maxValuePoint?.score * maxValueScale : undefined;

    return {
        logic: {
            maxValue,
        },
    };
};
